/**
 * Removes the redundant AI intro from patient instructions (section title already implies it).
 * Strips optional list markers (•, 1., -, *), markdown asterisks, optional "Please ", and punctuation after the phrase.
 * Drops a line that is only that phrase; if the phrase is followed by more text on the same line, keeps the rest.
 */
const FIND_BELOW_INTRO =
  /^(?:please\s+)?find\s+below\s+a\s+summary\s+of\s+the\s+plan/i;

export function removeFindBelowSummaryBoilerplateLine(text: string): string {
  if (!text) {
    return '';
  }
  const mapped: string[] = [];
  for (const line of text.replace(/\r/g, '').split('\n')) {
    const next = stripFindBelowIntroFromLine(line);
    if (next !== null) {
      mapped.push(next);
    }
  }
  const out = mapped.join('\n').replace(/(\n\s*){3,}/g, '\n\n');
  return out.replace(/^\n+/, '').replace(/\n+$/, '');
}

/** Returns null if the whole line should be removed; otherwise the line with any intro prefix stripped. */
function stripFindBelowIntroFromLine(line: string): string | null {
  const m = line.match(/^(\s*)(.*)$/s);
  const indent = m?.[1] ?? '';
  const rawBody = m?.[2] ?? '';

  let core = rawBody.trimStart();
  core = core.replace(/^(?:•\s+|\d{1,2}\.\s+|[-*]\s+)/, '').trimStart();
  core = core.replace(/^\*+/, '').replace(/\*+$/, '').trim();

  if (!core) {
    return line;
  }

  const introMatch = core.match(FIND_BELOW_INTRO);
  if (!introMatch || introMatch.index !== 0) {
    return line;
  }

  let after = core.slice(introMatch[0].length);
  after = after.replace(/^\s*[.:]+/, '').replace(/^\*+/, '').replace(/\*+$/, '').trim();

  if (!after) {
    return null;
  }
  return indent + after;
}
